type PresenceSound = 'join' | 'leave';

let sharedContext: AudioContext | null = null;
let unlockInstalled = false;

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (sharedContext) return sharedContext;

  const Ctor = window.AudioContext || (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;

  sharedContext = new Ctor();
  return sharedContext;
}

function unlockPresenceAudio() {
  const context = getAudioContext();
  if (!context || context.state === 'running') return;
  void context.resume().catch(() => undefined);
}

export function installPresenceAudioUnlock() {
  if (unlockInstalled || typeof window === 'undefined') return;
  unlockInstalled = true;
  window.addEventListener('pointerdown', unlockPresenceAudio, { passive: true });
  window.addEventListener('touchstart', unlockPresenceAudio, { passive: true });
  window.addEventListener('keydown', unlockPresenceAudio);
}

function tone(context: AudioContext, frequency: number, startsAt: number, duration: number, gainValue: number) {
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(frequency, startsAt);
  gain.gain.setValueAtTime(0.0001, startsAt);
  gain.gain.exponentialRampToValueAtTime(gainValue, startsAt + 0.018);
  gain.gain.exponentialRampToValueAtTime(0.0001, startsAt + duration);
  oscillator.connect(gain);
  gain.connect(context.destination);
  oscillator.start(startsAt);
  oscillator.stop(startsAt + duration + 0.02);
}

export function playPresenceSound(kind: PresenceSound) {
  installPresenceAudioUnlock();
  const context = getAudioContext();
  if (!context) return;

  const play = () => {
    const now = context.currentTime + 0.015;
    if (kind === 'join') {
      // Bright ascending double chime.
      tone(context, 659.25, now, 0.13, 0.085);
      tone(context, 987.77, now + 0.105, 0.19, 0.075);
    } else {
      // Softer descending chime, clearly different from join.
      tone(context, 587.33, now, 0.14, 0.07);
      tone(context, 392.0, now + 0.11, 0.22, 0.065);
    }
  };

  if (context.state === 'running') {
    play();
    return;
  }

  void context.resume().then(play).catch(() => undefined);
}

installPresenceAudioUnlock();
